import React, {useEffect, useState} from 'react';
import {Row, Col} from 'react-bootstrap';
import {t} from 'react-switch-lang';
import './Dashboard.scss';
import Chart from '../../components/chart/Chart';
import {GetLastExpiringMeasures} from '../../services/MeasuresCardApi/measuresCardApi';
import MeasuresCard from '../../components/Measures/MeasuresCard';
import DashboardTable from './components/DashboardTables';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import {useUserContext} from '../../contexts/UserContext';
import roles from '../../utils/roles';
import Findings from './components/Findings';

const Dashboard = () => {
  const [measuresCards, setMeasuresCards] = useState();
  const [userInternalRevision, setUserInternalRevision] = useState(false);
  const [userRisk, setUserRisk] = useState(false);
  const user = useUserContext();

  const revisionRoles = [
    roles.role_super_admin,
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_internal_audit_responsible,
    roles.role_sector_director,
    roles.role_admin
  ];
  const riskRoles = [
    roles.role_admin,
    roles.role_user_in_charge,
    roles.role_responsible_user,
    roles.role_technological
  ]
  const departments = useDepartmentContext();

  const userAuthorities = useUserContext().authorities;

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );

  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    const riskResult = riskRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setUserInternalRevision(result.length > 0);
    setUserRisk(riskResult.length > 0);
  }, [user]);

  const fetchData = async () => {
    try {
      const {data} = await GetLastExpiringMeasures();
      setMeasuresCards(data);
    } catch (err) {
      if (err) {
        // console.log(err);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className="h-100 w-100 pb-3">
      <Row className="pb-5 pt-3 px-5">
        {departments.some((r) => r.id === 9) ||
        userSuperAdmin ||
        userRiskSector ? (
          <>
            <Chart
              api={'/risks/chart-by-risk-estimation'}
              title={t('chart.titleFirstChart')}
            />
            <Chart
              api={'/risks/chart-by-risk-status'}
              title={t('chart.titleSecondChart')}
            />
            <Chart
              api={'/risks/chart-by-court-risk-estimation'}
              title={t('chart.titleThirdChart')}
            />
            <Chart
              api={'/risks/chart-by-court-risk-status'}
              title={t('chart.titleFourthChart')}
            />
          </>
        ) : (
          userRisk &&
          <>
            <Chart
              api={'/risks/chart-by-risk-estimation-potential'}
              title={t('chart.potentialFirst')}
            />
            <Chart
              api={'/risks/chart-by-risk-status-potential'}
              title={t('chart.potentialSecond')}
            />
            <Chart
              api={'/risks/chart-by-risk-estimation-incurred'}
              title={t('chart.incurredFirst')}
            />
            <Chart
              api={'/risks/chart-by-risk-status-incurred'}
              title={t('chart.incurredSecond')}
            />
          </>
        )}
      </Row>

      {(userRisk || userSuperAdmin) && <DashboardTable />}
      {(userRisk || userSuperAdmin) &&
      <Row className="px-5 mt-3 py-3">
        <Col xs="12" lg="12" className="mb-3">
          <Row className="dashboardHeader mx-1">
            <Col xs="12" md="6" className="dashboardHeaderTitle p-0">
              {t('measures.riskMitigationMeasures')}
            </Col>
            <Col xs="12" md="6" className="text-right p-0"></Col>
          </Row>
        </Col>
        {measuresCards !== undefined
          ? measuresCards.length > 0
            ? measuresCards.map((card, index) => (
                <Col xs="12" md="6" lg="3" key={index} className="mb-2">
                  <Row>
                    <Col xs="12" className="dashboardCards">
                      <MeasuresCard card={card} />
                    </Col>
                  </Row>
                </Col>
              ))
            : <Col className="no-measures" style={{textAlign: "center"}}>{t('common.noData')}</Col>
          : ''}
      </Row> }
      {userInternalRevision &&
        <Row className="px-5 mt-3 py-3">
          <Col xs="12" lg="12" className="mb-3">
            <Row className="dashboardHeader mx-1">
              <Col xs="12" md="6" className="dashboardHeaderTitle p-0">
                {t('revisions.findings')}
              </Col>
            </Row>
          </Col>
          <Findings/>
        </Row>
      }
    </div>
      </>
  );
};

export default Dashboard;
